import React from 'react';
import {withStore} from "../../hocs";
import {observer} from "mobx-react";
import {Link} from 'react-router-dom';

interface Props {
    item: {};
    isDetail: boolean;
    card?: boolean;

}

// @ts-ignore
@withStore
@observer
export class BasketItem extends React.Component<Props, {}> {

    render() {
        let item: any = this.props.item;
        let isDetail: boolean = this.props.isDetail;
        let isCard: boolean = Boolean(this.props?.card);
        let price = parseFloat(item.price?.final_price);
        let codeItem = item.code

        // @ts-ignore
        const {store} = this.props;
        const {
            minusCount,
            addCount,
            addProduct,
            getCount,
            changeProductInputCatalog,
            getMultiplicityCount
        } = store?.pageBasketStore;
        const {
            reloadForActualPrice
        } = store?.pageCardStore;
        const {clientId,user} = store?.mainStore;
        
        if (!clientId) {
            return null;
        }

        let isBasket = false;
        if (item?.basket?.count) {
            isBasket = true;
        }

        if(user?.type==='clientGuest'){
            return null
        }

        let multiplicity = getMultiplicityCount(item);
        
        return (
            <>
                <div className={isDetail ? "goods-content-basket card-basket" : "goods-content-basket"} style={isDetail ? {marginTop: 0} : {}}>
                    {price ? <>
                            <div className="basket-count">
                                <div className="circle-count" onClick={() =>(minusCount(item), reloadForActualPrice(codeItem)) }>
                                    <img className="" src="/img/ico/minus.svg" alt=""/>
                                </div>
                                <span className="added-count">
                                    <input
                                        type="text"
                                        onChange={(e) => (changeProductInputCatalog(e, item), reloadForActualPrice(codeItem) )}
                                        className="input-box-input"
                                        value={getCount(item)}
                                    />

                                </span>
                                {multiplicity > 1 ? <span className='multiplicity'>Кратно:{multiplicity} шт.</span> : null}
                              {/* <span className='multiplicity'>Кратно:{multiplicity} шт.</span>  */}
                                <div className="circle-count" onClick={() => (addCount(item),reloadForActualPrice(codeItem))}>
                                    <img className="" src="/img/ico/plus.svg" alt=""/>
                                </div>
                            </div>
                            {isBasket ? <div className="to-basket">
                                <Link className={"to-basket__btn in-basket"} to={'/basket'}>
                                    <span className="to-basket__text in-basket">В корзине</span>
                                </Link>
                            </div> : <div className="to-basket" onClick={() => (addProduct(item), reloadForActualPrice(codeItem))}>
                                <button className="to-basket__btn " type="submit">
                                    <span className="to-basket__text ">В корзину</span>
                                </button>
                            </div>}
                        </>
                        : null}
                </div>
                {isCard ? <div className="display-mobile-flex" style={isDetail ? {marginTop: 0} : {}}>
                    {isBasket ? <div className="to-basket">
                        <Link className={"to-basket__btn in-basket"} to={'/basket'}>
                            <span className="to-basket__text in-basket">В корзине</span>
                        </Link>
                    </div> : <div className="to-basket" onClick={() => (addProduct(item), reloadForActualPrice(codeItem))}>
                        <button className="to-basket__btn " type="submit">
                            <span className="to-basket__text ">В корзину</span>
                        </button>
                    </div>}
                </div> : null}
            </>
        );
    }
}